export default "__VITE_ASSET__BagYqQJU__"